// Bundle MapLibre GL JS, HTMX, Alpine.js, and PostHog analytics
// Exposes them as globals for existing code compatibility

// MapLibre v6 is ESM-only with named exports and no default, so the namespace is the global.
import * as maplibregl from 'maplibre-gl';
import htmx from 'htmx.org';
import Alpine from 'alpinejs';

// Analytics (initializes PostHog on import)
import './analytics';

// v6 loads its tile worker from a URL instead of inlining it, and a bundled build has no
// import.meta to resolve against. esbuild.config.js copies the worker and the chunk it imports
// into public/js/, so the map fetches them from the site root. Without this the worker never
// starts, and the map renders an empty canvas with no error.
maplibregl.setWorkerUrl('/js/maplibre-gl-worker.mjs');

// Expose to global scope
(window as unknown as Record<string, unknown>).maplibregl = maplibregl;
(window as unknown as Record<string, unknown>).htmx = htmx;
(window as unknown as Record<string, unknown>).Alpine = Alpine;

// Start Alpine after DOM is ready
// This ensures custom components (like editorState) are defined before Alpine initializes
document.addEventListener('DOMContentLoaded', () => {
  Alpine.start();
});
